import RestClient from './RestClient';
import { AccountPspCredential } from '../../models';

class AccountPspCredentials extends RestClient {
    constructor() {
        super({
            model: AccountPspCredential,
            entryPoint: 'account_psp_credential',
            resource: 'account_psp_credential',
            resources: 'account_psp_credentials',
            sortBy: 'label'
        });
    }
}

const AccountPspCredentialsApi = new AccountPspCredentials();

export default AccountPspCredentialsApi;
